module.exports = __webpack_public_path__ + "img/02_content_03.f71c3924.png";